import { render, staticRenderFns } from "./ModalSplitField.vue?vue&type=template&id=aaf740e0&scoped=true&"
import script from "./ModalSplitField.vue?vue&type=script&lang=js&"
export * from "./ModalSplitField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf740e0",
  null
  
)

export default component.exports